import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spring } from 'react-spring';
import Swal from 'sweetalert2';
import { history } from '../../helpers';
import Loading from '../../components/Loading/Loading';
import { WhitelabelActions, alertActions } from '../../store/actions';
import { constants } from '../../Constants';
import HeaderComponent from '../../components/Header';
import Footer from '../../components/Footer/footer';
import '../../static/css/styles.css';
import { API_ROOT_URL } from '../../config';
import Select from 'react-select';
import { serviceTypeActions } from "../../store/actions/serviceType.actions";

class CreateProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialWL: null,
      name: '',
      error_name: '',
      domain: '',
      subDomain: '',
      error_domain: '',
      emailDomain: '',
      error_emailDomain: '',
      subsidiaries: '',
      error_subsidiary: '',
      producer_role: '',
      consumer_role: '',
      payment: false,
      file: '',
      error_logo: '',
      mode: 'create',
      selectedId: '',
      loading: false,
      serviceTypes: [],
      serviceTypeSelected: [],
      total_session_cap: '',
      patient_session_cap: '',
      is_session_cap_allowed: false,
      error_service_type: '',
      isFamilyMemberAllowed: false,
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.createProject = this.createProject.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentWillMount() {
    this.props.fetchServiceType();
  }

  componentDidMount() {
    if (
      this.props.whitelabel &&
      this.props.selectedWhitebel &&
      this.props.selectedWhitebel !== ""
    ) {
      const obj = this.props.whitelabel.find(
        (w) => w.id === this.props.selectedWhitebel
      );

      let serviceTypeSelected = []
      if (obj) {
		if (obj.service_types.length > 0){
          obj.service_types.forEach(type => {
            serviceTypeSelected.push({
              value: type.id,
              label: type.name
            })
          })
        }
      }
      const emailDomainAllowed = Array.isArray(obj.email_domain)
      ? obj.email_domain.map(domain => domain.replace(/"/g, '').trim())
      : obj.email_domain.split(",").map(domain => domain.replace(/"/g, '').trim());
      const emailDomainContainsAll = emailDomainAllowed.includes("all");
     
      this.setState({
        initialWL: obj,
        selectedId: this.props.selectedWhitebel,
        name: obj.name,
        domain: obj.domain,
        subDomain: obj.sub_domain,
        emailDomain: emailDomainContainsAll ? "" : emailDomainAllowed.join(","),
        subsidiaries: obj.subsidiaries.join(","),
        producer_role: obj.producer_role,
        consumer_role: obj.consumer_role,
        payment: obj.payment_required,
        mode: "edit",
        loading: false,
        serviceTypeSelected,
        total_session_cap: obj.total_session_cap,
        patient_session_cap: obj.patient_session_cap,
        is_session_cap_allowed: obj.is_session_cap_allowed,
        isFamilyMemberAllowed: obj.is_add_family_member_allowed
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !!nextProps &&
      nextProps.serviceTypes &&
      nextProps.serviceTypes.service_types
    ) {
      this.setState({ serviceTypes: nextProps.serviceTypes.service_types });
    }
  }

  changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "payment" || name === "is_session_cap_allowed" || name === 'isFamilyMemberAllowed') {
      this.setState({ [name]: e.target.checked });
    } else if (name === "file") {
      this.setState({ [name]: e.target.files[0] });
    } else {
      this.setState({ [name]: value });
    }
  };
  changeServiceType = (serviceTypeSelected) => {
    this.setState({ serviceTypeSelected });
  };

  validate = () => {
    const urlRegex =
      /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    const alphaNumericRegex = /^[a-zA-Z0-9-]+(?: [a-zA-Z0-9-]+)*$/; 
    const emailDomainRegex = /^[a-zA-Z0-9,-]+{all}$/;
    let nameFlag,
      logoFlag,
      domainFlag,
      emailDomainFlag = true,
      serviceTypeFlag;
    let {
      name,
      domain,
      subDomain,
      subsidiaries,
      emailDomain,
      file,
      consumer_role,
      producer_role,
      payment,
      mode,
      error_domain,
      error_emailDomain,
      error_name,
      error_subsidiary,
      serviceTypeSelected,
      error_logo,
      error_service_type
    } = this.state;
    if (name.trim() === "") {
      error_name = constants.ENTER_NAME_ERROR_TXT;
      nameFlag = false;
    } else if (!alphaNumericRegex.test(name.trim())) {
      error_name = constants.ENTER_VALID_NAME_ERROR_TXT;
      nameFlag = false;
    } else {
      error_name = "";
      nameFlag = true;
    }
    if (domain === "") {
      error_domain = domain === "" ? "Please enter domain URL" : "";
      domainFlag = false;
    } else {
      domainFlag = true;
      error_domain = "";
    }
    if (domain !== "") {
      if (urlRegex.test(domain)) {
        domain =
          domain.indexOf("https://") > -1
            ? domain.replace("https://", "")
            : domain;
        domain =
          domain.indexOf("http://") > -1
            ? domain.replace("http://", "")
            : domain;
        domain =
          domain.indexOf("www") > -1 ? domain.replace("www.", "") : domain;

        if (domain.split(".").length > 2) {
          error_domain = "";
          domainFlag = true;
        } else {
          error_domain = "Please provide a valid domain URL";
          domainFlag = false;
        }
      } else {
        error_domain = "Please provide a valid domain URL";
        domainFlag = false;
      }
    }
    if (file === "" && mode !== "edit") {
      error_logo = file === "" ? "Please select logo" : "";
      logoFlag = false;
    } else {
      logoFlag = true;
      error_logo = "";
    }
    if (!Array.isArray(serviceTypeSelected) || serviceTypeSelected.length === 0) {
      error_service_type = constants.SELECT_SERVICE_TYPE_ERROR_TXT;
      serviceTypeFlag = false;
    }
    else{
      error_service_type = "",
      serviceTypeFlag = true;
    }

    if (emailDomain !== "") {
      if (emailDomain === "all") {
        error_emailDomain = "Leave empty to accept all domains";
        emailDomainFlag = false;
      } else if (emailDomain.indexOf(",") > -1) {
        if (emailDomain.split(",").includes("all")) {
          error_emailDomain = '"All" cannot be used with other domains. Leave empty to accept all domains.';
          emailDomainFlag = false;
        } else {
          emailDomain.split(",").forEach((item) => {
            if (urlRegex.test(item.trim())) {
              error_emailDomain = "";
              emailDomainFlag = true;
            } else {
              error_emailDomain = "Please provide a valid email domain.";
              emailDomainFlag = false;
              return;
            }
          });
        }
      } else {
        if (urlRegex.test(emailDomain)) {
          error_emailDomain = "";
          emailDomainFlag = true;
        } else {
          error_emailDomain = "Please provide a valid email domain.";
          emailDomainFlag = false;
        }
      }
    }

    this.setState({
      subDomain,
      emailDomain,
      error_domain,
      error_emailDomain,
      error_name,
      error_subsidiary,
      error_logo,
      error_service_type
    });
    return nameFlag && domainFlag && logoFlag && emailDomainFlag && serviceTypeFlag;
  };

  createProject = (e) => {
    const urlRegex =
      /^(https?|ftp|torrent|image|irc):\/\/(-\.)?([^\s\/?\.#-]+\.?)+(\/[^\s]*)?$/i;
    e.preventDefault();

    const {
      name,
      initialWL,
      domain,
      subDomain,
      subsidiaries,
      emailDomain,
      file,
      consumer_role,
      producer_role,
      payment,
      selectedId,
      total_session_cap,
      patient_session_cap,
      is_session_cap_allowed,
      isFamilyMemberAllowed,
      serviceTypeSelected
    } = this.state;

    if (this.validate()) {
      let allowedEmails = "";
      if (emailDomain !== "" && emailDomain.length > 0) {
        if (emailDomain.indexOf(",") > -1) {
          const emails = emailDomain.split(",");
          emails.forEach((item) => {
            let email = item;
            allowedEmails = `${allowedEmails},${email.toString()}`;
          });
        } else {
          allowedEmails = emailDomain.toString();
        }
      } else allowedEmails = "all";

      allowedEmails =
        allowedEmails.indexOf("https://") > -1
          ? allowedEmails.replace("https://", "")
          : allowedEmails;
      allowedEmails =
        allowedEmails.indexOf("http://") > -1
          ? allowedEmails.replace("http://", "")
          : allowedEmails;
      allowedEmails =
        allowedEmails.indexOf("www.") > -1
          ? allowedEmails.replace("www.", "")
          : allowedEmails;
      allowedEmails =
        allowedEmails.indexOf("[") > -1
          ? allowedEmails.replace("[", "")
          : allowedEmails;
      allowedEmails =
        allowedEmails.indexOf("]") > -1
          ? allowedEmails.replace("]", "")
          : allowedEmails;
      allowedEmails =
        allowedEmails.indexOf("@") > -1
          ? allowedEmails.replace("@", ".")
          : allowedEmails;

      allowedEmails = allowedEmails.replace(/(^,)|(,$)/g, "");

      let url = domain;
      let subDomain = "";
      if (url !== "") {
        url = url.indexOf("https://") > -1 ? url.replace("https://", "") : url;
        url = url.indexOf("http://") > -1 ? url.replace("http://", "") : url;
        url = url.indexOf("www.") > -1 ? url.replace("www.", "") : url;

        if (url.split(".").length > 1) {
          subDomain = url.split(".")[0];
        }
      }

      let subCompanies = subsidiaries !== "" ? subsidiaries : "Employees";
      const roleCounsellor =
        producer_role.length > 0 ? producer_role.toString() : "Counsellor";
      const rolePatient =
        consumer_role.length > 0 ? consumer_role.toString() : "Patient";
      let fd = new FormData();

      let svcTypPL = []
      serviceTypeSelected && serviceTypeSelected.length > 0 && serviceTypeSelected.forEach(
        type => svcTypPL.push(type.value)
      )

      if (!initialWL || initialWL === "") {
        fd.append("name", name.toString());
        fd.append("domain", url.toString());
        fd.append("sub_domain", subDomain.toString());
        fd.append("sys_domain", url.toString());
        fd.append("email_domain", allowedEmails.trim());
        fd.append("subsidiaries", subCompanies);
        fd.append("logo_url", file);
        fd.append("payment_required", payment ? "True" : "False");
        fd.append("slot_threshold", "24");
        fd.append("consumer_role", rolePatient);
        fd.append("producer_role", roleCounsellor);
        fd.append("is_counsellor_project", "False");
        fd.append('service_types', JSON.stringify(svcTypPL))
        fd.append('total_session_cap', Number(total_session_cap))
        fd.append('patient_session_cap', Number(patient_session_cap))
        fd.append('is_session_cap_allowed', is_session_cap_allowed)
        fd.append('is_add_family_member_allowed', isFamilyMemberAllowed)
      } else {
        if (initialWL.name !== name) fd.append("name", name.toString());
        if (initialWL.domain !== url) fd.append("domain", url.toString());
        if (initialWL.sub_domain !== subDomain)
          fd.append("sub_domain", subDomain.toString());
        if (initialWL.sys_domain !== url)
          fd.append("sys_domain", url.toString());
        fd.append("email_domain", allowedEmails.trim());
        if (initialWL.subsidiaries !== subCompanies)
          fd.append("subsidiaries", subCompanies);
        if (file) fd.append("logo_url", file);
        if (initialWL.payment_required !== payment)
          fd.append("payment_required", payment ? "True" : "False");
        if (initialWL.producer_role !== roleCounsellor)
          fd.append("producer_role", roleCounsellor);
        if (initialWL.consumer_role !== rolePatient)
          fd.append("consumer_role", rolePatient);

        fd.append('service_types', JSON.stringify(svcTypPL))
        fd.append('total_session_cap', Number(total_session_cap))
        fd.append('patient_session_cap', Number(patient_session_cap))
        fd.append('patient_session_cap', Number(patient_session_cap))
        fd.append('is_session_cap_allowed', is_session_cap_allowed)
        fd.append('is_add_family_member_allowed', isFamilyMemberAllowed)
      }
      this.props.setWhitelabel(fd, selectedId);
    }
  };

  componentWillUnmount() {
    this.props.resetWhitelabel();
  }

  cancel = () => {
    const { mode } = this.state;
    if (mode === "edit") history.push("/projects");
    else history.push("/home");
  };

  render() {
    const { alert, message } = this.props;
    const {
      file,
      error_logo,
      name,
      error_name,
      domain,
      error_domain,
      subsidiaries,
      error_subsidiary,
      emailDomain,
      error_emailDomain,
      producer_role,
      total_session_cap,
      patient_session_cap,
      consumer_role,
      payment,
      mode,
      initialWL,
      loading,
      serviceTypes,
      serviceTypeSelected,
      is_session_cap_allowed,
      isFamilyMemberAllowed,
      error_service_type
    } = this.state;

    let optionServiceType = [];
    if (serviceTypes && serviceTypes.length > 0) {
      serviceTypes.map((typ) => {
        return optionServiceType.push({ value: typ.id, label: typ.name });
      });
    }

    if (this.props.showLoading) {
      return <Loading />;
    } else {
      return (
        <div className="ContainerFix">
          <HeaderComponent />
          <Spring
            from={{ transform: "translate(+100%, 0)" }}
            to={{ transform: "translate(0%, 0)" }}
          >
            {(props) => (
              <div className="" style={props}>
                <div
                  className="row mt-5 mx-auto w-75 pb-5"
                  id="cardButtonContainer"
                >
                  {/* HEADING CONTAINER STARTS HERE */}
                  <div className="heading-container">
                    <p className="lead heading-line">
                      {constants.WHITELABEL_TXT}
                    </p>
                    <p className="lead heading-text">
                      {mode === constants.CREATE_TXT.toLowerCase()
                        ? constants.CREATE_WHITELABEL_TXT
                        : constants.UPDATE_WHITELABEL_TXT}
                    </p>
                    <hr className="lead--heading-line" />
                  </div>
                  {/* HEADING CONTAINER ENDS HERE */}
                  {/* FORM STARTS HERE */}
                  <form name="project-form" className="form-container">
                    {message && message.length > 0 && (
                      <div
                        className={`alert text-center alert-danger error-message`}
                        id="errorMessage"
                      >
                        {message}
                      </div>
                    )}
                    <div className="form-row">
                      <div className="form-group col-md-5 col">
                        <label htmlFor="inputname" className="label-text">
                          {constants.NAME_TXT}
                          <span className="input-required">*</span>
                        </label>
                        <input
                          type="name"
                          name="name"
                          value={name}
                          className="form-control"
                          id="inputname"
                          placeholder="e.g., IBA or Engro"
                          onChange={this.changeHandler}
                        />
                        {error_name.length > 0 && (
                          <span className="input-required">{error_name}</span>
                        )}
                      </div>

                      <div className="offset-md-2 custom-file col-md-5">
                        <p className="label-text">
                          {constants.UPLOAD_LOGO_TXT}
                          <span className="input-required">*</span>
                        </p>
                        <div className="input-group mb-3">
                          <input
                            type="file"
                            accept={[".jpg", ".png"]}
                            className="custom-file-input"
                            name="file"
                            id="inputGroupFile01"
                            onChange={this.changeHandler}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                            {file ? file.name : mode === "edit" && initialWL !== ""
                              ? initialWL.logo_url.replace(/^.*[\\\/]/, "")
                              : file
                                ? file.name.replace(/^.*[\\\/]/, "")
                                : "Choose file"}
                          </label>
                          {error_logo.length > 0 && (
                            <span className="input-required">{error_logo}</span>
                          )}
                        </div>
                      </div>

                      <div className="form-group col-md-5">
                        <label htmlFor="inputdomain" className="label-text">
                          {constants.DOMAIN_TXT}
                          <span className="input-required">*</span>
                        </label>
                        <input
                          type="domain"
                          className="form-control"
                          value={domain}
                          name="domain"
                          id="inputdomain"
                          placeholder="e.g., IBA.Saayahealth.com"
                          onChange={this.changeHandler}
                        />
                        {error_domain.length > 0 && (
                          <span className="input-required">{error_domain}</span>
                        )}
                      </div>

                      <div className="offset-md-2 form-group col-md-5">
                        <label htmlFor="inputemailend" className="label-text">
                          {constants.EMAIL_DOMAIN_TXT}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputemailend"
                          name="emailDomain"
                          onChange={this.changeHandler}
                          placeholder="e.g., engro.com, hotmail.com"
                          value={emailDomain}
                        />
                        {error_emailDomain.length > 0 && (
                          <span className="input-required">
                            {error_emailDomain}
                          </span>
                        )}
                      </div>

                      <div className="form-group col-md-5">
                        <label htmlFor="inputcompanies" className="label-text">
                          {constants.SUBSIDIARIES_TXT}
                        </label>
                        <input
                          type="text"
                          name="subsidiaries"
                          className="form-control"
                          id="inputcompanies"
                          placeholder="Provide subsidiaries here"
                          onChange={this.changeHandler}
                          value={subsidiaries}
                        />
                        {error_subsidiary.length > 0 && (
                          <span className="input-required">
                            {error_subsidiary}
                          </span>
                        )}
                      </div>

                      <div className="offset-md-2 form-group col-md-5">
                        <label htmlFor="inputprice" className="label-text">
                          {constants.PRODUCER_ROLE_TXT}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputprice"
                          placeholder="e.g. Doctor or Counsellor"
                          name="producer_role"
                          value={producer_role}
                          onChange={this.changeHandler}
                        />
                      </div>

                      <div className="form-group col-md-5">
                        <label
                          htmlFor="inputqualification"
                          className="label-text"
                        >
                          {constants.CONSUMER_ROLE_TXT}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputqualification"
                          placeholder="Optional"
                          name="consumer_role"
                          value={consumer_role}
                          onChange={this.changeHandler}
                        />
                      </div>

                      <div className="offset-md-2 form-group col-md-5">
                        {/* <label htmlFor="inputrelationship" className="label-text">
												Payment Required
											</label> */}
                        <label className="text-center counsellor-text">
                          <input
                            type="checkbox"
                            className="mr-1"
                            id="inputrelationship"
                            placeholder="Optional"
                            name="payment"
                            onChange={this.changeHandler}
                            checked={payment}
                          />
                          {constants.PAYMENT_REQUIRED_TXT}
                        </label>
                      </div>
                      <div className="form-group col-md-5">
                        <label
                          htmlFor="languagesSelected"
                          className="label-text"
                        >
                          {constants.SELECT_SERVICE_TYPE_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <Select
                          value={serviceTypeSelected}
                          isMulti
                          name="serviceTypeSelected"
                          options={optionServiceType}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={this.changeServiceType}
                        />
                        {error_service_type.length > 0 && (
                          <span className="input-required">
                            {error_service_type}
                          </span>
                        )}
                      </div>
                      <div className="offset-md-2 form-group col-md-5">
                        <label htmlFor="total_session_cap" className="label-text">
                          {constants.TOTAL_SESSION_CAP_TXT}
                        </label>
                        <input
                          disabled={!is_session_cap_allowed}
                          type="number"
                          className="form-control"
                          id="total_session_cap"
                          placeholder="Total session cap"
                          name="total_session_cap"
                          value={is_session_cap_allowed ? total_session_cap : ''}
                          onChange={this.changeHandler}
                        />
                      </div>
                      <div className="form-group col-md-5">
                        <label htmlFor="patient_session_cap" className="label-text">
                          {constants.PATIENT_SESSION_CAP_TXT}
                        </label>
                        <input
                          disabled={!is_session_cap_allowed}
                          type="number"
                          className="form-control"
                          id="patient_session_cap"
                          placeholder="Patient session cap"
                          name="patient_session_cap"
                          value={is_session_cap_allowed ? patient_session_cap : ''}
                          onChange={this.changeHandler}
                        />
                      </div>
                      <div className="offset-md-2 form-group col-md-5 d-flex flex-column">
                        {/* <label htmlFor="inputrelationship" className="label-text">
												Payment Required
											</label> */}
                        <label className="counsellor-text">
                          <input
                            type="checkbox"
                            className="mr-1"
                            id="is_session_cap_allowed"
                            placeholder="Optional"
                            name="is_session_cap_allowed"
                            onChange={this.changeHandler}
                            checked={is_session_cap_allowed}
                          />
                          {constants.IS_SESSION_CAP_ALLOWED_TXT}
                        </label>
                        <label className="counsellor-text">
                          <input
                            type="checkbox"
                            className="mr-1"
                            id="is_family_member_allowed"
                            placeholder="Optional"
                            name="isFamilyMemberAllowed"
                            onChange={this.changeHandler}
                            checked={isFamilyMemberAllowed}
                          />
                          {constants.IS_FAMILY_MEMBER_ALLOWED_TXT}
                        </label>
                      </div>
                    </div>
                    <div className="marginTop25 textAlignCenter">
                      <button
                        className="cancel-submit-button"
                        onClick={this.cancel}
                      >
                        {constants.CANCEL_TXT}
                      </button>
                      <button
                        type="submit"
                        className="appintment-submit-button"
                        onClick={this.createProject}
                      >
                        {mode === constants.CREATE_TXT.toLowerCase()
                          ? constants.CREATE_TXT
                          : constants.SAVE_TXT}
                      </button>
                    </div>
                  </form>{" "}
                  {/* FORM ENDS HERE */}
                </div>
              </div>
            )}
          </Spring>
          <Footer />
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  const { alert, serviceTypes } = state;
  const authstate = state.auth;
  const { whitelabel, selectedWhitebel, showLoading, message } =
    state.whitelabel;

  return {
    alert,
    authstate,
    whitelabel,
    selectedWhitebel,
    showLoading,
    message,
    serviceTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setWhitelabel: (obj, id) => {
      dispatch(WhitelabelActions.setWhitelabel(obj, id));
    },
    resetWhitelabel: () => {
      dispatch(WhitelabelActions.resetWhitelabel());
    },
    fetchWhitelabel: () => {
      dispatch(WhitelabelActions.fetchWhitelabel());
    },
    clearAlertActions: () => {
      dispatch(alertActions.clear());
    },
    alertError: (message) => {
      dispatch(alertActions.error(message));
    },
    fetchServiceType: () => {
      dispatch(serviceTypeActions.fetchServiceType());
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateProject));



// WEBPACK FOOTER //
// ./src/screens/CreateProject/index.js